<template>
  <div>
    <div class="deviceManagement">
      <CommonForm
        :form="form"
        :searchItems="searchItems"
        @search="handleSearchChange"
        @clear="clear"
      />

      <div class="operate-box">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="openDrawer()"
        >
          添加动作
        </el-button>
        <div></div>
        <!-- <el-button icon="el-icon-download" size="small" @click="handleExport">
          下载
        </el-button> -->
      </div>

      <CommonTable
        ref="listRef"
        v-loading="loading"
        :columns="columns"
        :tableData="tableData"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <template v-slot:index="row">
          <span>{{ row }}</span>
        </template>

        <template v-slot:videoTime="{ row }">
          <span>{{ row.videoTime + "s" }}</span>
        </template>

        <template v-slot:image="{ row }">
          <img :src="row.image" alt="" class="avatar" />
        </template>

        <template v-slot:enable="{ row }">
          <el-switch
            v-model="row.enable"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="handleEnable(row)"
          />
        </template>

        <template v-slot:actions="{ row }">
          <el-button type="text" size="small" @click="handleVideo(row)">
            预览
          </el-button>
           <el-button type="text" size="small" @click="revamp(row)">
            编辑
          </el-button>
          <el-button type="text" size="small" @click="deleteID(row)">
            删除
          </el-button>
        </template>
      </CommonTable>

      <VideoDialog ref="videoRef" />
      <CommonDrawer
        ref="Drawer"
        :title="drawerTitle"
        :type="drawerType"
        :form="drawerForm"
        :formItems="formItems"
        @submit="submitDrawer"
      />

    </div>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable";
import CommonForm from "@/components/CommonForm";
import VideoDialog from "@/components/VideoDialog";
import CommonDrawer from "@/components/el-drawer";

import { getMovementList, startMovement, getMovementTypeList, addMovement, getMovementDetail, editMovement, deleteMovement } from "@/api/movement";

export default {
  components: {
    CommonTable,
    CommonForm,
    VideoDialog,
    CommonDrawer,
  },
  data() {
    return {
      columns: [
        { prop: "image", label: "封面" },
        { prop: "typeName", label: "任务类型" },
        { prop: "name", label: "动作名称" },
        { prop: "introduction", label: "简介" },
        { prop: "tags", label: "标签" },
        { prop: "enable", label: "是否启用" },
        { prop: "actions", label: "操作" },
      ],
      tableData: [ ],
      form: {},
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      loading: false,
      drawerForm: {},
      // 动作类型
      movementTypeList: [],
      drawerType: "add",
      drawerTitle: "添加动作",
    };
  },
  computed: {
    searchItems() {
      return [
        {
          type: "select",
          value: "type",
          label: "任务类型",
          options: [
            {
              label: "训练",
              value: "training",
            },
            {
              label: "挑战",
              value: "challenge",
            },
          ],
        },
      ];
    },
    formItems() {
      return [
        {
          type: "radio",
          value: "type",
          label: "任务类型",
          required: true,
          options: [
            {
              label: "训练",
              value: "training",
            },
            {
              label: "挑战",
              value: "challenge",
            },
          ],
        },
        {
          type: "select",
          value: "categoryId",
          label: "动作类型",
          required: true,
          options: this.movementTypeList,
        },
        {
          type: "input",
          value: "name",
          label: "动作名称",
          required: true,
        },
        {
          type: "upload",
          value: "image",
          label: "封面图",
          required: true,
        },
        {
          type: "input",
          value: "tags",
          label: "标签",
          required: true,
        },
        {
          type: "number",
          value: "difficulty",
          label: "难度等级",
          required: true,
        },
        {
          type: "textarea",
          value: "introduction",
          label: "简介",
          required: false,
        },
        {
          type: "video",
          value: "video",
          label: "视频",
          required: true,
        },
      ];
    }
  },
  mounted() {
    this.getData();
    this.getTypeList();
  },
  methods: {
    // 清除某一个条件出触发搜索
    clear(values) {
      this.form = values;
      this.getData();
    },
    getData() {
      const { page, size } = this.pagination;
      this.loading = true;
      const prams = {
        page,
        size,
        ...this.form,
      };
      getMovementList(prams).then((res) => {
        const {
          data: { list = [], total },
        } = res;
        this.pagination.total = total;
        this.loading = false;
        this.tableData = list.map((item) => {
          return {
            ...item,
            enable: item.enable ? true : false,
          };
        });
      });
    },
    gotoPage(val) {
      this.pagination.page = val;
      this.getData();
    },
    // 列表页码切换
    handleTableChange({ page, pageSize }) {
      this.pagination.page = page;
      this.pagination.pageSize = pageSize;
      this.getData();
    },
    // 搜索
    handleSearchChange(values) {
      this.form = values;
      this.gotoPage();
    },
    // 查看视频
    handleVideo(item) {
      this.$refs.videoRef.init({
        videoUrl: item.video,
      });
    },
    openDrawer() {
      this.drawerType = "add";
      this.drawerTitle = "添加动作";
      this.drawerForm = {};
      this.$refs.Drawer.init();
    },
    // 是否启用动作
    handleEnable(row) {
      startMovement(row.id).then((res) => {
        console.log(res);
      });
    },
    // 新增动作
    submitDrawer(form, type) {
      const funApi = type === 'add' ? addMovement : editMovement;
      const title = type === 'add' ? '添加成功' : '编辑成功';

      funApi(form).then(res => {
        this.$notify({ title, type: 'success' });
        this.getData();
      })
    },
    // 编辑动作
    revamp(row) {
      this.drawerType = "update",
      this.drawerTitle = "编辑动作",

      getMovementDetail(row.id).then((res) => {
        this.drawerForm = res.data;
        this.$refs.Drawer.init()
      });
    },
    // 获取动作分类
    getTypeList() {
      getMovementTypeList().then((res) => {
        this.movementTypeList = res.data.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
      });
    },
    deleteID(row) {
      deleteMovement(row.id).then((res) => {
        this.$notify({ title: '删除成功', type: 'success' });
        this.getData();
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.deviceManagement {
  .operate-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  }
}

.avatar {
  width: 50px;
}
</style>
